import Confirm from '@/components/common/Confirm.vue';
import { ConstantUtil } from '@/utils/ConstantUtil';
import settings from '@/utils/settings';
import Balance from '@/utils/balance';
import BigNumber from 'bignumber.js';
import * as types from '@/store/mutation-types';
import {
    mapState,
} from 'vuex';
import Config from '@/utils/Config';
import RUC from '@/utils/Ruc';

export default {
    name: 'Withdraw',
    props: ['balance', 'currTarget', 'address', 'availableBtt'],
    data() {
        return {
            confirmStatus: false,
            withdraw: {
                curr: {
                    address: '',
                    amount: '',
                },
            },
            userId: '',
            currIndex: -1,
            withdrawFeeConfig: undefined,
        };
    },
    computed: {
        ...mapState({
            storeConfirmStatus: state => state.confirmStatus,
            user: state => state.user,
        }),
        withdrawAddress() {
            const inputAddress = this.withdraw.curr.address;
            if (ConstantUtil.BCHID.has(this.currTarget.id)) {
                return ConstantUtil.toBCHAddress(inputAddress);
            }
            return inputAddress;
        },
        fee() {
            if(!this.withdraw.curr.amount) return 0;
            const {
                channelWithdrawMinFee,
                channelWithdrawMinFeeRate,
                pixiuWithdrawMinFee = "0",
            } = this.withdrawFeeConfig || {};
            let result = BigNumber(0);
            if (channelWithdrawMinFee){
                result = BigNumber(pixiuWithdrawMinFee).plus(channelWithdrawMinFee);
            } else if (channelWithdrawMinFeeRate) {
                result = BigNumber(this.withdraw.curr.amount)
                    .times(channelWithdrawMinFeeRate)
                    .plus(pixiuWithdrawMinFee);
            } else if(pixiuWithdrawMinFee) {
                result = BigNumber(pixiuWithdrawMinFee);
            }
            if(result.isLessThan(0)) result = BigNumber(0);
            return result.toFixed();
                
        },
        withdrawable() {
            const {
                channelWithdrawMinFee,
                channelWithdrawMinFeeRate,
                pixiuWithdrawMinFee = "0",
            } = this.withdrawFeeConfig || {};

            console.log([
                channelWithdrawMinFee,
                channelWithdrawMinFeeRate,
                pixiuWithdrawMinFee,
                this.balance,
            ])
            let result;
            if (channelWithdrawMinFee){
                result = BigNumber(this.balance)
                    .minus(pixiuWithdrawMinFee)
                    .minus(channelWithdrawMinFee);
            } else if(channelWithdrawMinFeeRate) {
                result = BigNumber(this.balance)
                    .minus(pixiuWithdrawMinFee)
                    .dividedBy(BigNumber(channelWithdrawMinFeeRate).plus(1));
            } else if(pixiuWithdrawMinFee) {
                result = BigNumber(this.balance).minus(pixiuWithdrawMinFee);
            } else {
                result = BigNumber(this.balance);
            }
            if(result.isLessThan(0)) result = BigNumber(0);
            return result.toFixed();
        }
    },
    components: {
        Confirm,
    },
    async mounted() {
        const {data:{assets:{[this.currTarget.id]: config={}}={}, transferFeeToAccount }={}} = await RUC.getDepositAddress(this.$store.getters.currAccount.userid);
        this.withdrawFeeConfig = { ...config, transferFeeToAccount};
    },
    methods: {
        showDialog() {
            const self = this;
            if (
                self.withdraw.curr === '' ||
                self.withdraw.curr.amount === '' ||
                self.withdraw.curr.amount === 0
            ) {
                return self.$Message.error(self.$t('balance_please_input_address_and_amount'));
            }
            if (
                BigNumber(self.withdraw.curr.amount).isGreaterThan(self.withdrawable)
            ) {
                return self.$Message.error(self.$t('trade_balance_not_enough'));
            }
            if (parseFloat(self.withdraw.curr.amount) < parseFloat(self.currTarget.pixiu_min_withdraw_amount)) {
                return self.$Message.error(`${self.$t('Theamountislessthantheminimum')} ${self.currTarget.pixiu_min_withdraw_amount}`);
            }
            if (Config.CenterTrade) {
                self.doWithDraw();
            } else {
                self.confirmStatus = true;
                self.currIndex = self.$store.state.currAccountIndex;
                self.$store.commit(types.CHANGE_CONFIRMSTATUS, true);
            }
            self.$emit('tempHideDialog', 'close');
            return null;
        },
        confirmAction(res) {
            const self = this;
            if (res.code === 0) {
                self.doWithDraw(res.password);
                self.confirmStatus = false;
                self.$emit('tempHideDialog', 'open');
            }
        },
        async doWithDraw(password) {
            const self = this;
            let accountInfo;
            if (Config.CenterTrade) {
                accountInfo = {
                    userid: self.user.bttUserid,
                };
            } else {
                const currindex = self.$store.state.currAccountIndex;
                accountInfo = self.$store.state.accountList[currindex];
            }
            self.userId = accountInfo.userid;

            if (Config.CenterTrade ||
                (this.$store.getters.currAccount &&
                    this.$store.getters.currAccount.ethereum)
            ) {
                const toExternalAddress = ConstantUtil.LikeBTCChainIds.includes(self.currTarget.chain_type) ? self.withdrawAddress : this.address;
                let ob = {};
                if (!Config.CenterTrade) {
                    ob = {
                        fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
                        from: self.userId,
                        to_external_address: toExternalAddress,
                        asset_type: self.currTarget.id,
                        amount: BigNumber(self.withdraw.curr.amount)
                            .times(self.currTarget.external_precision)
                            .toFixed(0),
                    };
                }
                if (!this.withdrawFeeConfig || !this.withdrawFeeConfig.transferFeeToAccount) return;
                try {
                    const feeTrObj = await Balance.getTransfer2Obj({
                        accountInfo,
                        password,
                        to: this.withdrawFeeConfig.transferFeeToAccount,
                        asset: self.currTarget,
                        amount: this.fee,
                    });
                    console.log({ feeTrObj, asset: self.currTarget });
                    const res = await Balance.withDrawAction({
                        accountInfo,
                        currTarget: self.currTarget,
                        password,
                        obb: ob,
                        targetAddress: self.withdrawAddress,
                        amount: self.withdraw.curr.amount,
                        feeTrObj,
                    });
                    if (res.code === 0) {
                        self.$Message.success(self.$t('balance_successful_withdraw'));
                        self.$emit('withdrawhidden');
                    } else if (res.code === 300003) {
                        self.$Message.error(self.$t('balance_please_input_valid_address', { asset: self.currTarget.asset }));
                    } else if (res.code === 100006) {
                        self.$Message.error(self.$t('trade_balance_not_enough', { asset: self.currTarget.asset }));
                    } else {
                        self.$Message.error('Error');
                    }
                } catch(e) {
                    self.$Message.error(self.$t(e));
                }
                self.$emit('withdrawhidden');
                self.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/withdraw.js